import { motion } from "framer-motion";

const PHOTOS = [
  { src: "/images/dave-pink.jpg", w: 667, h: 960, alt: "Dave Williams holding his granddaughter", caption: "Grandpa's girl" },
  { src: "/images/dave-horse.jpg", w: 472, h: 590, alt: "Dave Williams riding horseback on the reservation", caption: "At home on the land" },
  { src: "/images/dave-faith.jpg", w: 1320, h: 1033, alt: "Dave Williams with family at a faith gathering", caption: "Faith & family" },
  { src: "/images/dave-tribe-time.jpg", w: 586, h: 315, alt: "Dave Williams and family in matching Tribe Time shirts", caption: "Tribe time" },
  { src: "/images/dave-powwow.jpg", w: 1000, h: 1400, alt: "Dave Williams with family in traditional dress at a gathering", caption: "In good company" },
  { src: "/images/dave-birthday.jpg", w: 1000, h: 831, alt: "Dave Williams and his wife celebrating a birthday", caption: "Celebrating together" },
  { src: "/images/dave-grandkids.jpg", w: 1000, h: 1063, alt: "Dave Williams with his wife and grandchildren", caption: "The next generation" },
  { src: "/images/dave-toddler.jpg", w: 787, h: 1398, alt: "Dave Williams hugging his young granddaughter", caption: "Pure joy" },
  { src: "/images/dave-family-trio.jpg", w: 1000, h: 1352, alt: "Dave Williams' family — three generations together", caption: "Three generations" },
  { src: "/images/dave-voted.jpg", w: 1000, h: 693, alt: "Dave Williams and family wearing I Voted stickers", caption: "The Future" },
  { src: "/images/dave-honor.jpg", w: 1000, h: 1155, alt: "Family honoring a veteran with a folded flag and portrait", caption: "Honoring our veterans" },
  { src: "/images/dave-community.jpg", w: 1000, h: 688, alt: "Dave Williams with family and friends at a community event", caption: "Together in community" },
  { src: "/images/dave-elder.jpg", w: 1000, h: 784, alt: "Dave Williams sharing a meal with an elder", caption: "With our elders" },
  { src: "/images/dave-outing.jpg", w: 1000, h: 711, alt: "Dave Williams with family on a day out", caption: "Family day out" },
  { src: "/images/dave-jerseys.jpg", w: 1000, h: 1478, alt: "Williams family selfie in matching jerseys", caption: "Team Williams" },
];

export default function PhotoGallery() {
  return (
    <section id="gallery" className="bg-[#F8F9FA] pb-24 md:pb-32 px-5 md:px-10" data-testid="photo-gallery">
      <div className="max-w-7xl mx-auto columns-1 sm:columns-2 lg:columns-3 gap-5 md:gap-8">
        {PHOTOS.map((p, i) => (
          <motion.figure
            key={p.src}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group relative overflow-hidden rounded-sm border border-navy/10 shadow-[0_24px_48px_-20px_rgba(10,25,47,0.3)] mb-5 md:mb-8 break-inside-avoid"
            data-testid={`story-photo-${i + 1}`}
          >
            <img
              src={p.src}
              alt={p.alt}
              width={p.w}
              height={p.h}
              className="w-full h-auto bg-navy/5 transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
            />
            <figcaption className="absolute bottom-3 left-3 text-[10px] uppercase tracking-[0.25em] text-white bg-navy/60 backdrop-blur-sm px-3 py-1.5 rounded-full">
              {p.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
